import React from 'react';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { FullWidthDivider } from '../../../styles';
import { LedgerHeader } from './header';
import './index.scss';


const LedgerDrawer = (props) => {
    return (
        <EaseDrawer
            className="ledger-drawer-wrapper"
            visible={props.visible}
            hideHeader
            hideFooter
            destroyOnClose
            title={false}
            width={500}
            onOpen={() => { }}
            onClose={props.toggleLedgerDrawer}
        >
            <div>
                <LedgerHeader ledger={props.ledger} />
                <FullWidthDivider />
            </div>
        </EaseDrawer>
    );
};

export { LedgerDrawer };